import state from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { Module } from 'vuex';
import BookingState from '@/types/store/booking/BookingState';
import RootState from '@/types/store/booking/RootState';

const module: Module<BookingState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
export default module;
